import { ReactNode } from 'react'

export enum ErrorVariant {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  WRONG_LINK = 'WRONG_LINK',
  BLOCKED_COOKIES = 'BLOCKED_COOKIES',
  LINK_ALREADY_USED = 'LINK_ALREADY_USED',
  OTP_MAX_ATTEMPTS_EXCEEDED = 'OTP_MAX_ATTEMPTS_EXCEEDED'
}

export type ErrorCardProps = {
  title: string
  subtitle?: string | null
  variant: ErrorVariant
  children?: ReactNode
}
